import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

function CheckBox(props) {
	const [checked, setChecked] = useState(props.checked)
	const idCheckBox = props.id || (new Date()).getTime()
	const keyCheckBox = 'input-'.concat(idCheckBox)
	const keyLabelCheckBox = 'label-'.concat(idCheckBox)
	const disabledClass = props.disabled ? 'im-checkbox-disabled' : ''
	const finalClassName = (props.className || 'im-checkbox').concat(' ', disabledClass)
	const haveOnChangeCallback = typeof props.onChange === 'function'


	useEffect(() => {
		if(props.checked !== checked && haveOnChangeCallback) {
			setChecked(props.checked)
		}
	}, [props.checked])


	const onClickCheckBox = (event) => {
		event.stopPropagation()
		if (props.disabled) return
		if (haveOnChangeCallback) {
			props.onChange(!checked, props.value)
		}
		setChecked(!checked)
	}


	return (<div
		className={finalClassName}
		key={props.value}
	>
		<input
			key={keyCheckBox}
			disabled={props.disabled}
			checked={checked}
			id={idCheckBox}
			type='checkbox'
			value={props.value}
			onClick={onClickCheckBox}
		/>
		<label key={keyLabelCheckBox} onClick={onClickCheckBox}>
			{props.labelText}
		</label>
		{props.children}
	</div>)
}


CheckBox.propTypes = {
	id: PropTypes.string,
	labelText: PropTypes.string,
	checked: PropTypes.bool,
	onChange: PropTypes.func,
	value: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.number,
		PropTypes.string
	])
}


export default CheckBox



// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/Wrapper/Checkbox.js